"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // TODO: pollyfill ImageData constructor

/**
 * Class to represent a RGBA pixel matrix (an image). This class aims to
 * abstract away the pixel related manipulations by providing a set of
 * convenience methods for iterating through pixels.
 */


var RgbaImageBuffer =
/*#__PURE__*/
function () {
  _createClass(RgbaImageBuffer, null, [{
    key: "fromImageData",

    /** Number of channels in a RGBA pixel */

    /**
     * Convenient function to create a RgbaImage instance from an ImageData object
     * where the width, height are copied but the pixel array is only copied the
     * references
     *
     * @param {ImageData} imgData ImageData instance to create the RgbaImage from
     * @returns {RgbaImageBuffer} Instance of RgbaImage initialized from the ImgData
     */
    value: function fromImageData(_ref) {
      var width = _ref.width,
          height = _ref.height,
          data = _ref.data;
      return new RgbaImageBuffer(width, height, data);
    }
    /**
     * Convenient function to create an ImageData object from a RgbaImage object
     *
     * @param {RgbaImageBuffer} rgbaImage Instance of RgbaImage used to create the
     * ImageData
     * @returns {ImageData} ImageData instance with a copy of the width, height
     * and pixels of the given RgbaImage
     */

  }, {
    key: "toImageData",
    value: function toImageData(_ref2) {
      var width = _ref2.width,
          height = _ref2.height,
          pixels = _ref2.pixels;
      var imgData = new ImageData(width, height);
      imgData.data.set(pixels);
      return imgData;
    }
    /**
     * Creates an instance of this class. Note: this treats the given pixels as
     * RGBA pixels
     *
     * @param {number} width Pixel matrix width
     * @param {number} height Pixel matrix height
     * @param {Uint8ClampedArray} pixels TypedArray of RGBA Pixels
     */

  }]);

  function RgbaImageBuffer(width, height, pixels) {
    var _this = this;

    _classCallCheck(this, RgbaImageBuffer);

    _defineProperty(this, "toImageData", function () {
      return RgbaImageBuffer.toImageData(_this);
    });

    _defineProperty(this, "copy", function () {
      return new RgbaImageBuffer(_this.width, _this.height, new Uint8ClampedArray(_this.pixels));
    });

    _defineProperty(this, "getPixel", function (_ref3) {
      var x = _ref3.x,
          y = _ref3.y;
      x = Math.max(0, Math.min(_this.width - 1, x));
      y = Math.max(0, Math.min(_this.height - 1, y));

      var pixelPosition = _this._mapMatrixPositionToArray(x, y); // We tested this way and it turned to be much more performant than using slice


      return [_this.pixels[pixelPosition], _this.pixels[pixelPosition + 1], _this.pixels[pixelPosition + 2], _this.pixels[pixelPosition + 3]];
    });

    _defineProperty(this, "_mapMatrixPositionToArray", function (x, y) {
      return (y * _this.width + x) * RgbaImageBuffer.NUM_CHANNELS;
    }); // TODO: check that everything is right (width, height > 0; width * height *
    // rgbaDimension = pixels.length; etc)


    this._width = width;
    this._height = height;
    this._pixels = pixels;
  }
  /** Alias for RgbaImage.toImageData(instanceOfRgbaImage) */


  _createClass(RgbaImageBuffer, [{
    key: "pixels",

    /**
     * @returns {Uint8ClampedArray} Pixels values of the image, an element for
     * each pixel dimension (4 in case of RGBA for example)
     */
    get: function get() {
      return this._pixels;
    }
    /** @returns {number} The width of the image */

  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
    /** @returns {number} The height of the image */

  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
    /**
     * Given a coordinate in matrix space (2 dimensions) this method returns the
     * corresponding coordinate in vector space (1 dimension).
     *
     * @param {number} x Horizontal coordinate
     * @param {number} y Vertical coordinate
     * @returns {number} Corresponding vector coordinate
     */

  }]);

  return RgbaImageBuffer;
}();

exports.default = RgbaImageBuffer;

_defineProperty(RgbaImageBuffer, "NUM_CHANNELS", 4);